<med-label
  [label]="label"
  [name]="name"
  [disabled]="disabled"
  [required]="required"
  [labelClass]="labelClass"
>
  <div
    class="field__row"
    [ngClass]="{ field__container: hasErrorPadding }"
  >
    <textarea
      #element
      class="med-textarea field"
      [ngStyle]="{ height }"
      [id]="name"
      [name]="name"
      [rows]="1"
      [attr.role]="role"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="placeholder"
      [ngClass]="classList"
      [(ngModel)]="value"
      (blur)="onBlur.emit($event)"
      (focus)="emitFocus($event)"
      (input)="onInputTextarea($event)"
    ></textarea>
  </div>

  <div
    *ngIf="invalid"
    [ngClass]="{ up: hasErrorPadding }"
    class="field__error-message"
  >
    {{ errorMessage }}
  </div>
</med-label>
